module.exports = __webpack_public_path__ + "static/media/renascena.69c48c9b.webp";